export default "__VITE_ASSET__CKEboHAH__"